<template>
    <div>
        <span v-if="$auth.check() && alarms.length > 0" v-for="log in alarms" @click="updateAlarmRead(log)"
              data-toggle="collapse" data-target="#navbarSupportedContent" class="unreadAlarm dropdown-item">
            <span v-if="log.type === 'QNA_NEW_QUESTION' || log.type === 'QNA_NEW_ANSWER'">Question</span>
            <span v-else>{{log.activityTitle}}</span>
            <span v-if="log.msg" :title="log.msg">
                {{log.msg}}
            </span>
            <span v-else :title="!!alarmMap[log.type] ? alarmMap[log.type]['msg'] : ''">
                {{!!alarmMap[log.type] ? alarmMap[log.type]['msg'] : ''}}
            </span>
        </span>
        <span class="dropdown-item" v-if="alarms.length == 0" data-toggle="collapse" data-target="#navbarSupportedContent">
            <i class="fa fa-check-circle"></i> 알림이 없습니다.
        </span>
    </div>
</template>
<script>
    import moment from 'moment';

    /* eslint-disable */
    export default {
        name: 'AlarmUnreadList',
        data() {
            return {
                alarms: [],
                alarmMap: {},
                search: {
                    page: 0,
                    size: 10,
                },
            }
        },
        components: {
        },
        methods: {

            getList() {
                if(!this.$auth.check()) return;

                let me = this;
                let u = new URLSearchParams(this.search).toString();

                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarm/unread/${this.$auth.user().id}?${u}`;
                //console.log(u);
                this.axios.get(url)
                    .then(function (res) {
                        me.alarms = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getAlarmTypeMap() {
                let me = this;
                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarmMap`;
                this.axios.get(url)
                    .then(function (res) {
                        me.alarmMap = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            updateAlarmRead(log) {
                let me = this;
                this.updateAlarmReadAll() // 모두 읽은걸로..
                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/${log.id}`)
                    .then(function (res) {
                        // QNA 알림이면 QnaShow로, msg에서 제목 추출해서 QNA 찾기
                        if(log.type === 'QNA_NEW_QUESTION' || log.type === 'QNA_NEW_ANSWER') {
                            // msg에서 질문 제목 추출
                            let titleMatch = log.msg.match(/: (.+)$/);
                            if (titleMatch) {
                                let title = titleMatch[1];
                                // QNA 목록 API를 호출해서 해당 제목의 질문 ID를 찾음
                                me.axios.get(`${process.env.VUE_APP_QNA_API_URL}/list`)
                                  .then(res => {
                                    if (res.data) {
                                      // 제목이 일치하는 질문 찾기
                                      const qna = res.data.find(q => q.title === title);
                                      if (qna) {
                                        me.$router.push({ name: 'qnaShow', params: { id: qna.id }});
                                      }
                                    }
                                  });
                            }
                        } else {
                          me.$router.push({ name: me.alarmMap[log.type]['url'], params: { id: log.activityId }});
                        }

                        const index = me.alarms.indexOf(log);
                        if (index > -1) {
                            me.alarms.splice(index, 1);
                        }

                        me.$parent.getUnreadCount()
                        me.getList()
                    }).catch(function (error) {
                    console.log(error);
                });

            },
            updateAlarmReadAll() {
                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/readall/${this.$auth.user().id}`)
                    .then(function (res) {
                    }).catch(function (error) {
                    console.log(error);
                });

            }
        },
        mounted() {
            this.getList();
            this.getAlarmTypeMap();
        },
        created() {
        },

        watch: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.unreadAlarm {
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
